"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _svg = _interopRequireDefault(require("../../svg/svg"));

var _visuallyHidden = _interopRequireDefault(require("../../visually-hidden/visually-hidden"));

var _topNav = require("../shared/top-nav.styles");

var _navLinks = _interopRequireDefault(require("../shared/nav-links"));

var _desktopUserNavSection = _interopRequireDefault(require("./desktop-user-nav-section"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var DesktopNav = function DesktopNav(_ref) {
  var activeLink = _ref.activeLink,
      buttonSection = _ref.buttonSection,
      routes = _ref.routes,
      user = _ref.user,
      userFetchState = _ref.userFetchState;
  var primaryRoutes = routes.primaryRoutes,
      userRoutes = routes.userRoutes;
  var logoLink = primaryRoutes.find(function (route) {
    return route.logoLink === true;
  });
  return /*#__PURE__*/_react["default"].createElement(_topNav.Nav, {
    "aria-labelledby": "nav-desktop-label",
    desktopOnly: true
  }, /*#__PURE__*/_react["default"].createElement(_visuallyHidden["default"], {
    id: "nav-desktop-label"
  }, "Main Menu"), /*#__PURE__*/_react["default"].createElement(_topNav.NavSection, null, /*#__PURE__*/_react["default"].createElement("a", {
    href: logoLink === null || logoLink === void 0 ? void 0 : logoLink.url,
    tabIndex: "0" // for some reason, screen readers aren't picking up this anchor tag.
    ,
    "aria-label": "Home Link"
  }, /*#__PURE__*/_react["default"].createElement(_svg["default"], {
    id: "glowforge-logo",
    width: null,
    height: "27px",
    stroke: "none"
  })), /*#__PURE__*/_react["default"].createElement(_topNav.NavUL, {
    role: "list"
  }, /*#__PURE__*/_react["default"].createElement(_navLinks["default"], {
    activeLink: activeLink,
    routes: primaryRoutes.filter(function (route) {
      return !route.logoLink;
    })
  }))), /*#__PURE__*/_react["default"].createElement(_topNav.NavSection, null, buttonSection, /*#__PURE__*/_react["default"].createElement(_desktopUserNavSection["default"], {
    user: user,
    userFetchState: userFetchState,
    routes: userRoutes,
    activeLink: activeLink
  })));
};

var _default = DesktopNav;
exports["default"] = _default;